import { z } from 'zod';
import { UUIDSchema } from '../domain/models';

export const VideoConsultInvitationType = ['sms', 'email', 'whatsapp'] as const;

const InvitationTypeSchema = z.enum(VideoConsultInvitationType);
export type VideoConsultInvitationType = z.infer<typeof InvitationTypeSchema>;

export const VideoConsultSendInvitationRequestSchema = z.object({
  roomId: z.string(),
  type: InvitationTypeSchema,
  subject: UUIDSchema.describe('Patient ID'),
});

export type VideoConsultSendInvitationRequest = z.infer<
  typeof VideoConsultSendInvitationRequestSchema
>;

export const VideoConsultSendInvitationResponseSchema = z.object({});

export const VideoConsultCreateRoomResponseSchema = z.object({
  token: z.string(),
  roomId: z.string(),
  joinRoomUrl: z.string(),
});

export type VideoConsultCreateRoomResponse = z.infer<
  typeof VideoConsultCreateRoomResponseSchema
>;

export type VideoConsultSendInvitationResponse = z.infer<
  typeof VideoConsultSendInvitationResponseSchema
>;

export const VideoConsultCreateRoomRequestSchema = z.object({
  subject: UUIDSchema.describe('Patient ID'),
});

export type VideoConsultCreateRoomRequest = z.infer<
  typeof VideoConsultCreateRoomRequestSchema
>;
